import React from 'react';
import Navbar from '../components/Navbar';
import BetaTesterForm from '../components/BetaTesterForm';
import Footer from '../components/Footer';

const BetaTesterPage: React.FC = () => {
  return (
    <>
      <Navbar />
      <div style={{ paddingTop: '80px' }}>
        <BetaTesterForm />
      </div>
      <Footer />
    </>
  );
};

export default BetaTesterPage;
